// extracted by mini-css-extract-plugin
export default {"resetButton":"FSUyH8I","item":"o6EUm_s","deleted":"kbyvLxw","afterDeleted":"P4OPyNM","prepend":"uVsBZp8","message":"bAjdKCU"};